export default "__VITE_ASSET__08ada790__"